import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { depositLimitSentence } from 'src/app/shared/constants/deposit-limit.messages';

/**
 * FIN-1708 · the fallback sentence, kept only for the case where no allowance has reached
 * the browser yet.
 *
 * ⚠ FIN-1708 shipped this as *the* copy, hardcoded, with a note that FIN-1711 owned the
 * real numbers. FIN-1711 replaced it: the sentence is now derived from the tier the
 * inversionista actually declared, and this literal survives only as the tier-1 wording it
 * always was — now *menos de S/ 5 000*, the band D136 restored, since the 4 999.99 tope is
 * a cent short of it on purpose.
 */
export const DEPOSIT_LIMIT_MESSAGE =
  'Por ahora puedes depositar menos de S/ 5 000 o USD 1 500.';

export type PreApprovedDepositPopupResult =
  | { deposit: true }
  | { sign: true }
  | { close: true };

/**
 * FIN-1708 · shown once, when an inversionista PN is pre-approved on submitting the LAFT
 * form. Three ways out, and `app.component` decides what each one means:
 *
 * - `deposit` → the cuenta bancaria, or straight to the deposit if they have one;
 * - `sign` → the Keynua widget, the same way the LAFT banner opens it;
 * - `close` → nothing; they stay on Oportunidades.
 *
 * The class stays thin like its two siblings (`pending-validation-popup`,
 * `investor-account-approved-dialog`): all three exits are the same dialog close with a
 * different result, and every one of them marks the popup seen.
 */
@Component({
  selector: 'app-pre-approved-deposit-popup',
  templateUrl: './pre-approved-deposit-popup.component.html',
  styleUrls: ['./pre-approved-deposit-popup.component.scss'],
})
export class PreApprovedDepositPopupComponent {
  /**
   * FIN-1711 · the inversionista's own allowance, set by `app.component` from the profile
   * so the popup, the deposit screen and the amount validator all state one figure.
   */
  @Input() depositAllowance: any = null;

  get limitMessage(): string | null {
    if (!this.depositAllowance) {
      return DEPOSIT_LIMIT_MESSAGE;
    }

    return depositLimitSentence(this.depositAllowance);
  }

  constructor(
    public dialogRef: MatDialogRef<PreApprovedDepositPopupComponent>
  ) {}

  deposit(): void {
    this.dialogRef.close({ deposit: true });
  }

  sign(): void {
    this.dialogRef.close({ sign: true });
  }

  /** The X and *Lo haré después* — the same exit, and it still marks the popup seen. */
  dismiss(): void {
    this.dialogRef.close({ close: true });
  }
}
